module.exports = __webpack_public_path__ + "static/media/kid8.aa4de364.png";